"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isProfileSubmitDisabled = (user, { firstName, lastName, phoneNumber, companyName }, phoneError) => {
    var _a, _b;
    if (!user) {
        return true;
    }
    const hasProfileChanges = [
        [firstName, user.firstName],
        [lastName, user.lastName],
        [phoneNumber, (_a = user.phoneNumber) !== null && _a !== void 0 ? _a : ''],
    ].some(([currentValue, initialValue]) => currentValue !== initialValue) ||
        (companyName !== undefined && companyName !== ((_b = user.companyName) !== null && _b !== void 0 ? _b : ''));
    const hasInvalidProfileFields = [firstName, lastName, phoneNumber].some((field) => !(field === null || field === void 0 ? void 0 : field.trim())) || Boolean(phoneError);
    return hasInvalidProfileFields || !hasProfileChanges;
};
exports.default = isProfileSubmitDisabled;
